var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.707,
    height: 42,
    viewBox: "0 0 97.707 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon3",
    transform: "translate(-12.5 -151.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10983",
    "data-name": "Caminho 10983",
    d: "M69.345,181.726a2.007,2.007,0,0,0-2.006-2.006H40.446a2.007,2.007,0,0,0-2.006,2.006v2.141a2.007,2.007,0,0,0,2.006,2.006H67.339a2.007,2.007,0,0,0,2.006-2.006Z",
    transform: "translate(-20.736 -22.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10984",
    "data-name": "Caminho 10984",
    d: "M69.345,242.676a2.007,2.007,0,0,0-2.006-2.006H40.446a2.007,2.007,0,0,0-2.006,2.006v2.141a2.007,2.007,0,0,0,2.006,2.006H67.339a2.007,2.007,0,0,0,2.006-2.006Z",
    transform: "translate(-20.736 -71.416)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10985",
    "data-name": "Caminho 10985",
    d: "M67.339,301.61H40.446a2.007,2.007,0,0,0-2.006,2.006v2.141a2.007,2.007,0,0,0,2.006,2.006H67.339a2.007,2.007,0,0,0,2.006-2.006v-2.141A2.006,2.006,0,0,0,67.339,301.61Z",
    transform: "translate(-20.736 -120.129)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10986",
    "data-name": "Caminho 10986",
    d: "M108.1,151.33H14.607a2.109,2.109,0,0,0-2.107,2.107v37.787a2.109,2.109,0,0,0,2.107,2.107H52.393a2.109,2.109,0,0,0,2.107-2.107V155.656a.7.7,0,0,0-1.4,0v35.568a.7.7,0,0,1-.7.7H14.607a.7.7,0,0,1-.7-.7V153.437a.7.7,0,0,1,.7-.7h53.6v36.513a.7.7,0,1,0,1.4,0V152.734H108.1a.7.7,0,0,1,.7.7v37.787a.7.7,0,0,1-.7.7H57.77a.7.7,0,1,0,0,1.4H108.1a2.109,2.109,0,0,0,2.107-2.107V153.437A2.109,2.109,0,0,0,108.1,151.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10987",
    "data-name": "Caminho 10987",
    d: "M415.844,184.538a4.434,4.434,0,1,0-4.434-4.434A4.439,4.439,0,0,0,415.844,184.538Zm0-7.461a3.023,3.023,0,0,1,2.311,1.075,3.685,3.685,0,0,0-.58-.048,3.732,3.732,0,0,0-3.732,3.732,3.447,3.447,0,0,0,.048.58,3.026,3.026,0,0,1,1.952-5.339Z",
    transform: "translate(-318.877 -19.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10988",
    "data-name": "Caminho 10988",
    d: "M415.844,300.988a4.434,4.434,0,1,0-4.434-4.434A4.439,4.439,0,0,0,415.844,300.988Zm0-7.461a3.023,3.023,0,0,1,2.311,1.075,3.683,3.683,0,0,0-.58-.048,3.732,3.732,0,0,0-3.732,3.732,3.446,3.446,0,0,0,.048.58,3.026,3.026,0,0,1,1.952-5.339Z",
    transform: "translate(-318.877 -112.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10989",
    "data-name": "Caminho 10989",
    d: "M415.844,242.768a4.434,4.434,0,1,0-4.434-4.434A4.439,4.439,0,0,0,415.844,242.768Zm0-7.463a3.023,3.023,0,0,1,2.311,1.075,3.687,3.687,0,0,0-.58-.048,3.732,3.732,0,0,0-3.732,3.732,3.447,3.447,0,0,0,.048.58,3.026,3.026,0,0,1,1.952-5.339Z",
    transform: "translate(-318.877 -66.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10990",
    "data-name": "Caminho 10990",
    d: "M338.484,184.538a4.434,4.434,0,1,0-4.434-4.434A4.439,4.439,0,0,0,338.484,184.538Zm0-7.461a3.023,3.023,0,0,1,2.311,1.075,3.685,3.685,0,0,0-.58-.048,3.732,3.732,0,0,0-3.732,3.732,3.44,3.44,0,0,0,.048.58,3.026,3.026,0,0,1,1.952-5.339Z",
    transform: "translate(-257.037 -19.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10991",
    "data-name": "Caminho 10991",
    d: "M338.484,300.988a4.434,4.434,0,1,0-4.434-4.434A4.439,4.439,0,0,0,338.484,300.988Zm0-7.461A3.023,3.023,0,0,1,340.8,294.6a3.683,3.683,0,0,0-.58-.048,3.732,3.732,0,0,0-3.732,3.732,3.44,3.44,0,0,0,.048.58,3.026,3.026,0,0,1,1.952-5.339Z",
    transform: "translate(-257.037 -112.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10992",
    "data-name": "Caminho 10992",
    d: "M338.484,242.768a4.434,4.434,0,1,0-4.434-4.434A4.439,4.439,0,0,0,338.484,242.768Zm0-7.463a3.023,3.023,0,0,1,2.311,1.075,3.687,3.687,0,0,0-.58-.048,3.732,3.732,0,0,0-3.732,3.732,3.44,3.44,0,0,0,.048.58,3.026,3.026,0,0,1,1.952-5.339Z",
    transform: "translate(-257.037 -66.004)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.1fb00ecfe91bcf1e55f5e6135a8573a8.svg";
export { ForwardRef as ReactComponent };